import { useRef, useState, useCallback, useEffect } from "react";
import { MoveHorizontal } from "lucide-react";

export function BeforeAfterSlider({ before, after, alt = "" }) {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const setFromClientX = useCallback((clientX) => {
    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, pct)));
  }, []);

  useEffect(() => {
    const onMove = (e) => {
      if (!dragging.current) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setFromClientX(clientX);
    };
    const onUp = () => (dragging.current = false);
    window.addEventListener("mousemove", onMove);
    window.addEventListener("touchmove", onMove);
    window.addEventListener("mouseup", onUp);
    window.addEventListener("touchend", onUp);
    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove", onMove);
      window.removeEventListener("mouseup", onUp);
      window.removeEventListener("touchend", onUp);
    };
  }, [setFromClientX]);

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="relative w-full aspect-[3/2] overflow-hidden rounded-lg select-none cursor-ew-resize bg-neutral-200"
      onMouseDown={(e) => { dragging.current = true; setFromClientX(e.clientX); }}
      onTouchStart={(e) => { dragging.current = true; setFromClientX(e.touches[0].clientX); }}
    >
      <img src={after} alt={`${alt} - après`} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute top-3 right-3 z-10 px-2.5 py-1 rounded-md bg-vegetal-600 text-white text-xs font-medium">Après</div>

      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt={`${alt} - avant`}
          className="absolute inset-0 h-full object-cover max-w-none"
          style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100%" }}
          draggable={false}
        />
        <div className="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-md bg-neutral-900/80 text-white text-xs font-medium">Avant</div>
      </div>

      <div className="absolute top-0 bottom-0 z-20 w-0.5 bg-white shadow-[0_0_8px_rgba(0,0,0,0.4)]" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-10 w-10 rounded-full bg-white shadow-lg grid place-items-center text-terracotta-600">
          <MoveHorizontal className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
}
